import Skeleton from '@mui/material/Skeleton';
import { useState } from 'react';

import { useSelector } from 'react-redux';
import BasicHeader from '/@/components/basic-header';
import Container from '/@/components/container';
import Drawing from '/@/components/drawing';
import Popup from '/@/components/popup';
import useDebounce from '/@/hooks/debounce/useDebounce';
import { useWeedsFromAPI } from '/@/hooks/weeds';
import { _ } from '/@/locale';
import { getSessionCountry } from '/@/store/session/selectors';
import { mpTrackEvent } from '/@/store/tracking/mixpanel-events';
import { isPhone } from '/@/utils';
import WeedDetail from '/@/views/weeds/weed-detail';
import WeedRow from './row';
import styles from './styles.module.css';

export default function WeedFinder() {
    const country = useSelector((state) => getSessionCountry(state));
    const [showPopup, setShowPopup] = useState(false);
    const [selectedWeed, setSelectedWeed] = useState(undefined);
    const [searchText, setSearchText] = useState('');
    const debouncedSearchText = useDebounce(searchText, 500);

    const { data: weeds, isValidating: loading } = useWeedsFromAPI(
        {
            countryCode: country.code,
            name: debouncedSearchText,
            showInFinder: true,
        },
        { enabled: !!country.code }
    );

    const handleClickWeed = (weed: any) => {
        setSelectedWeed(weed);
        setShowPopup(true);
        mpTrackEvent('Weed detail opened', { entry_source: 'weed-finder' });
    };

    const handleClosePopup = () => {
        setShowPopup(false);
    };

    return (
        <Container backgroundColor='gray-light'>
            <div className={styles.root}>
                <div className={styles.container}>
                    <BasicHeader
                        className={styles.header}
                        title={_('Buscador de malezas')}
                        searchPlaceholder={_('Buscar por nombre')}
                        searchText={searchText}
                        onChangeSearch={(value) => setSearchText(value)}
                    />
                    {loading ? (
                        <div className={styles.noResults}>
                            <Skeleton variant='rounded' />
                        </div>
                    ) : !weeds?.length ? (
                        <Drawing type='library-not-found' title={_('No se encontraron resultados para tu búsqueda.')} />
                    ) : (
                        <div className={styles.masonry}>
                            {weeds.map((weed: any) => (
                                <WeedRow
                                    key={weed.id}
                                    weed={weed}
                                    showImage={true}
                                    loadImage={true}
                                    handleClickWeed={() => handleClickWeed(weed)}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </div>
            <Popup
                visible={showPopup}
                onClose={handleClosePopup}
                showCloseIcon
                stretch={!isPhone()}
                className={styles.popupWeedFinder}
            >
                {selectedWeed && <WeedDetail weed={selectedWeed} />}
            </Popup>
        </Container>
    );
}
